import './ContactUs.css'
import React from 'react'

const contactUs = ()=>{
    return (
        <div className="contactUs">
            <div className="form">
                <form>
                    <label>Full Name:</label>
                    
                </form>
            </div>
        </div>
    )
}
export default contactUs;